import { BookOpen, Heart, Smile } from 'lucide-react';
import { Panel, Row, Note } from '@/features/home/composer/studio/styles';
import type {
  AuthoredAttachments as Attachments,
  Perspectives,
} from '@/features/home/composer/studio/contracts';
import { safeSource } from '@/features/home/composer/studio/safeSource';
export function AuthoredAttachments({
  attachments,
  perspectives,
}: {
  attachments?: Attachments;
  perspectives?: Perspectives;
}) {
  if (!attachments && !perspectives) return null;
  return (
    <div onClick={(e) => e.stopPropagation()} style={{ display: 'grid', gap: 10 }}>
      {attachments?.mood && (
        <Row>
          <Smile size={16} aria-hidden="true" />
          <span>
            {attachments.mood.emoji} {attachments.mood.label}
          </span>
        </Row>
      )}
      {attachments?.context && (
        <Panel>
          <Row>
            <BookOpen size={17} aria-hidden="true" />
            <strong>Context from the author</strong>
          </Row>
          <p style={{ whiteSpace: 'pre-wrap' }}>{attachments.context.body}</p>
          {attachments.context.sources
            .filter((s) => safeSource(s.url))
            .map((s, i) => (
              <a key={i} href={s.url} target="_blank" rel="noopener noreferrer">
                {s.label || new URL(s.url).hostname}
              </a>
            ))}
        </Panel>
      )}
      {perspectives && (
        <Panel>
          <strong>{perspectives.title || 'Perspectives'}</strong>
          {perspectives.viewpoints.map((v) => (
            <div key={v.id}>
              {v.unavailable ? (
                <Note>Perspective unavailable</Note>
              ) : (
                <>
                  <h4>{v.label}</h4>
                  <Note>
                    {v.authorship === 'contributor' ? 'Contributed by' : 'Written by'}{' '}
                    {v.author?.name} (@{v.author?.handle?.replace(/^@/, '')})
                  </Note>
                  <p style={{ whiteSpace: 'pre-wrap' }}>{v.text}</p>
                </>
              )}
            </div>
          ))}
          {perspectives.commonGround && (
            <div>
              <strong>Common ground</strong>
              <p>{perspectives.commonGround}</p>
            </div>
          )}
        </Panel>
      )}
      {attachments?.cherishPrompt && (
        <Row>
          <Heart size={17} aria-hidden="true" />
          <p>{attachments.cherishPrompt}</p>
        </Row>
      )}
    </div>
  );
}
